<template>
	<section
		class="profile-selector-wrapper"
		:class="{ open: expandedProfileSelector }"
		:key="userId"
	>
		<div class="profile-selector-search" v-if="isInternalUser">
			<font-awesome-icon
				class="profile-search-icon"
				:icon="['fal', 'search']"
			/>
			<input
				type="search"
				class="profile-broker-id-search"
				placeholder="Broker Id"
				@keyup.enter="
					(e) => {
						getAeBrokerDetails(e.target.value);
					}
				"
			/>
		</div>
		<section class="profile-selector-list" :key="profileSelectorIndex">
			<div
				v-if="mainUser !== null && !isInternalUser"
				class="branch-person"
				role="button"
				tabindex="0"
				@click="
					switchProfile(mainUser.organizationId, mainUser.userId),
						toggleExpandedProfileSelector()
				"
				@keyup.enter="
					switchProfile(mainUser.organizationId, mainUser.userId),
						toggleExpandedProfileSelector()
				"
			>
				<img
					v-if="
						mainUser.profilePhoto != null &&
						mainUser.profilePhoto.imageUri !== ''
					"
					:src="mainUser.profilePhoto.imageUri"
					alt="fullName"
				/>
				<img v-else src="@/assets/default-headshot.png" alt="fullName" />
				<span class="profile-name"
					>{{ mainUser.firstName }} {{ mainUser.lastName }}</span
				>
			</div>
			<div
				class="branch-selector"
				v-for="(brokerShop, brokerIndex) in shopDetails"
				:key="brokerIndex"
			>
				<input
					type="checkbox"
					class="branch-checkbox"
					:id="`branch-${brokerIndex}`"
					:name="`branch-${brokerIndex}`"
				/>
				<label
					:id="`branch-tab-${brokerIndex}`"
					class="tab-label"
					:for="`branch-${brokerIndex}`"
					tabindex="0"
					@keyup.enter="toggleBranch($event)"
					v-if="
						brokerShop.shopDetail.brokerName !== null &&
						brokerShop.shopDetail.brokerName !== ''
					"
				>
					{{ brokerShop.shopDetail.brokerName }}
					<font-awesome-icon
						class="branch-toggle"
						:icon="['fal', 'chevron-circle-down']"
					/>
				</label>
				<div class="ae-shop-error" v-else>No Broker Shop Found</div>
				<section
					id="available-users"
					class="tab-content tab-content--profile-list"
					v-if="
						brokerShop.shopDetail.brokerName !== null &&
						brokerShop.shopDetail.brokerName !== ''
					"
				>
					<label
						id="company-tab-label"
						class="tab-label tab-secondary tab-sticky"
						:for="`branch-${brokerIndex}`"
						tabindex="0"
						@keyup.enter="toggleBranch($event)"
					>
						<font-awesome-icon
							class="branch-toggle"
							:icon="['fas', 'caret-right']"
						/>
						{{ brokerShop.shopDetail.brokerName }}
					</label>
					<button
						v-for="(user, userIndex) in brokerShop.users"
						:key="userIndex"
						class="branch-person profile-list"
						:class="{
							isActive: user.userId === currentUser.userId,
							disabled: !user.termsOfUse,
						}"
						:disabled="!user.termsOfUse"
						role="button"
						tabindex="0"
						:data-test="`branch-button-${userIndex}`"
						@click="
							switchProfile(brokerShop.organizationId, user.userId),
								toggleExpandedProfileSelector(),
								clickBranchTab(brokerIndex)
						"
						@keyup.enter="
							switchProfile(brokerShop.organizationId, user.userId),
								toggleExpandedProfileSelector()
						"
					>
						<!-- user.profilePhoto.imageUri !== '' &&  -->

						<span class="profile-name">
							<img
								v-if="user.profilePhoto !== null && user.profilePhoto.imageUri"
								:src="user.profilePhoto.imageUri"
								:alt="`${user.firstName} ${user.lastName}`"
								@error="handleImageError(userIndex, brokerIndex)"
							/>

							<img
								v-else
								src="@/assets/default-headshot.png"
								:alt="`${user.firstName} ${user.lastName}`"
							/>
							{{ user.firstName }} {{ user.lastName }}
						</span>
						<font-awesome-icon
							v-if="!user.termsOfUse"
							class="tooltip-target b360-form-icon"
							:icon="['far', 'exclamation-circle']"
							v-tooltip="{
								content: `In order to access this user’s profile, please advise them to launch Brand 360 and accept the Terms of Use.`,
								trigger: 'hover click',
								placement: 'top-end',
							}"
						/>
					</button>
				</section>
			</div>
		</section>
	</section>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import profileApiClient from '@/services/profile/profile-service.js';

export default {
	name: 'ProfileSelectorWrapper',
	data() {
		return {
			profileSelectorIndex: 0,
			toggleOpen: false,
		};
	},
	computed: {
		...mapState({
			expandedProfileSelector: (state) => state.menus.expandedProfileSelector,
			isInternalUser: (state) =>
				state.profileSwitcher.profileSelector.isInternalUser,
			userId: (state) => state.profile.userId,
			mainUser: (state) => state.profileSwitcher.mainProfile,
			currentUser: (state) => state.profile,
			shopDetails: (state) => {
				if (
					state.profileSwitcher.mainProfileSelector.brokerShopDetails !==
						null &&
					state.profileSwitcher.mainProfileSelector.brokerShopDetails.length > 0
				) {
					return state.profileSwitcher.mainProfileSelector.brokerShopDetails;
				} else if (
					state.profileSwitcher.brokerDetails != null &&
					state.profileSwitcher.brokerDetails.length > 0
				) {
					return state.profileSwitcher.brokerDetails;
				} else {
					return [];
				}
			},
		}),
	},
	methods: {
		...mapActions([
			'toggleExpandedProfileSelector',
			'setImpersonatedUser',
			'setAeBrokerDetails',
			'resetClientConnectAlerts',
			'resetClientConnectLeads',
			'resetFambState',
		]),
		toggleBranch(event) {
			event.target.click();
		},
		clickBranchTab(brokerIndex) {
			document.getElementById(`branch-tab-${brokerIndex}`).click();
		},
		getAeBrokerDetails(brokerId) {
			profileApiClient.getBrokerDetails(brokerId);
		},
		async switchProfile(organizationId, userId) {
			this.resetFambState();
			await Promise.all([
				profileApiClient.getProfile(organizationId, userId),
				profileApiClient.getProfileSelector(organizationId, userId),
			]);
			// reset Client Connect state when user switch profiles. This will be used to refresh
			// client connect v2.0 data with the impersonated users alerts and contacts.
			this.resetClientConnectAlerts(true);
			this.resetClientConnectLeads();
		},
		handleImageError(userIndex, brokerIndex) {
			this.shopDetails[brokerIndex].users[userIndex].profilePhoto = null;
		},
	},
};
</script>

<style scoped lang="scss">
.tab-sticky {
	position: sticky;
	top: 0;
}

button.disabled {
	cursor: not-allowed;
	border: 1px solid #c3c3c3;

	&:hover {
		cursor: not-allowed;
		color: $b360-color--gray__medium;
		background: $b360-color--gray__header-bg;
	}
}

.profile-selector-wrapper {
	position: absolute;
	top: 81px;
	background-color: $white;
	left: 0;
	height: 100vh;
	right: 0;
	bottom: 0;
	z-index: 1;
	opacity: 0;
	visibility: hidden;
	transition: all 0.5s ease-in-out;
	overflow-y: hidden;

	&.open {
		opacity: 1;
		visibility: visible;
	}

	.profile-selector-search {
		position: relative;
		padding: 12px;
		display: flex;
		border-bottom: $b360-border-width-thin solid $border-color-light;

		.profile-search-icon {
			position: absolute;
			top: 18px;
			left: 18px;
			color: $brand-blue;
		}

		.profile-broker-id-search {
			height: 30px;
			@include typo--roboto__regular;
			font-size: $b360-font-size--base;
			color: $text-base-color;
			padding: 4px 4px 4px 30px;
			width: 100%;
			border-radius: $b360-border-radius-base;
			border: $b360-border-width-thin solid $border-color-light;
		}
	}
} //end .profile-selector-wrapper

.profile-selector-list {
	position: relative;

	.branch-checkbox {
		position: absolute;
		opacity: 0;
		z-index: -1;
	}

	.branch-selector {
		width: 100%;
		color: $b360-color--gray__darkest;
		overflow: hidden;

		.tab-label {
			@include typo--roboto__medium;
			@include rem(padding, 15px);
			display: flex;
			justify-content: space-between;
			align-items: center;
			background: $white;
			font-weight: bold;
			color: $brand-blue;
			cursor: pointer;
			border-left: $b360-border-radius-small solid transparent;
			border-right: $b360-border-width-thin solid $border-color-light;
			border-bottom: $b360-border-width-thin solid $border-color-light;
			font-size: $b360-font-size--base;

			&.tab-secondary {
				font-size: $b360-font-size--large;
				justify-content: end;

				svg .branch-toggle {
					margin-right: 10px;
				}
			}

			.branch-toggle {
				color: $brand-blue;
				font-size: $b360-font-size--larger;
				text-align: center;
			}

			&:hover,
			&:focus {
				border-left: $b360-border-radius-small solid $brand-blue;
				background-color: $highlight-color;
				color: $brand-blue;
				cursor: pointer;
			}
		}

		.ae-shop-error {
			display: flex;
			justify-content: space-between;
			align-items: center;
			@include rem(padding, 15px);
			background: $white;
			font-weight: bold;
			border-left: $b360-border-radius-small solid transparent;
			border-bottom: $b360-border-width-thin solid $border-color-light;
			@include typo--roboto__medium;
			font-size: $b360-font-size--base;
		}

		.tab-content {
			color: $white;
			background: $white;
			transition: all 0.3s ease-in-out;
			transform: translateX(290px);
			overflow-y: auto;
			height: 100vh;
			position: absolute;
			top: 0;
			left: 0;
			right: 0;

			@include mobile {
				transform: translateX(100%);
			}

			&--profile-list {
				position: fixed;
				height: calc(100vh - 162px);
				top: 162px;
				left: 0;

				@include tablet {
					max-width: $expanded-menu-width;
					left: -$expanded-menu-width;
				}

				&::-webkit-scrollbar {
					width: 7px;
					background: none;
				}

				&::-webkit-scrollbar-thumb {
					background: $brand-blue;
				}
			}
		}
	} // end .branch-selector

	// when the branch name is :checked
	input:checked {
		~ .tab-content {
			color: $text-base-color;
			transform: translateX(0px);
		}
	}
} // end profile-selector-list

.branch-person {
	@include typo--roboto__medium;
	display: flex;
	align-items: center;
	width: 100%;
	padding: 12px;
	font-size: $b360-font-size--base;
	cursor: pointer;
	border: none;
	border-left: $b360-border-radius-small solid transparent;
	border-bottom: $b360-border-width-thin solid $border-color-light;
	background-color: $white;

	&:hover,
	&:focus,
	&.isActive {
		border-left: $b360-border-radius-small solid $brand-blue;
		background-color: $highlight-color;
		color: $brand-blue;
		cursor: pointer;
	}

	&.profile-list {
		justify-content: space-between;
	}

	&.disabled:hover {
		color: $b360-color--gray__medium;
		background: $b360-color--gray__header-bg;
	}

	img {
		width: 24px;
		height: 24px;
		margin-right: 10px;
		border-radius: $b360-border-radius-base;
	}

	.profile-name {
		line-height: 1;
		display: inline-flex;
		align-items: center;
	}
}
</style>
